import React, { FC } from 'react'
import s from './KuperBannerFirst.module.sass'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { Title } from '@shared/ui/Typography/Title'
import { Text } from '@shared/ui/Typography/Text'
import KuperPillow from '@images/Kuper/kuper-pillow.png'
import { Button } from '@shared/ui/Actions/Button'
import { AdvertBadge } from '@shared/ui/Feedback/AdvertBadge'
import AdvDetailed from '@features/Common/AdvDetailed/AdvDetailed'
import Link from 'next/link'
import useFeatureFlag from '@shared/lib/hooks/useFeatureFlag'

interface Props {
  sizes: string
  data: {
    restName: string
    link: string
    description: string
    token: string
  }
  className?: string
}

const sizeTitle = { L: 'h1', M: 'h2', S: 'h4' }
const sizeAdvertBadge = { L: '62x23', M: '62x23', S: '54x19' }

const sizeDescription = {
  L: 'ML',
  M: 'M',
  S: 'S',
}

const KuperBannerFirst: FC<Props> = ({ sizes, data, className = '' }) => {
  const [size] = useCurrentSize(sizes)

  const isDevMode = useFeatureFlag('kuper')
  if (!isDevMode) return null

  return (
    <Link href={data.link} className={`${s.banner} ${className}`} data-size={size}>
      <div className={s.content}>
        <div className={s.header}>
          <AdvertBadge sizes={sizeAdvertBadge[size]} />
          <AdvDetailed>
            <AdvDetailed.Button className={s['info-button']} />
            <AdvDetailed.Popup description={data.description} token={data.token} />
          </AdvDetailed>
        </div>
        <div className={s.main}>
          <div className={s.information}>
            <Title className={s.title} sizes={sizeTitle[size]}>
              Закажите доставку
            </Title>
            <Text sizes={sizeDescription[size]} className={s.description}>
              Блюда из <span className={s['rest-name']}>{data.restName}</span> привезет Купер
            </Text>
          </div>
          <div className={s['image-wrapper']}>
            <img src={KuperPillow.src} alt={'Купер'} />
          </div>

          {size !== 'S' && (
            <Link href={data.link} className={s['button-link']}>
              <Button className={s.button} sizes={'XL'} mode={'black'}>
                {size === 'L' ? 'Заказать доставку' : 'Заказать'}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </Link>
  )
}

export default KuperBannerFirst
